import React from 'react';
import './TopContactBar.css';

function TopContactBar() {
  return (
    <div className="top-contact-bar">
      <div className="contact-bar-content">
        <div className="contact-info">
          <a href="mailto:admin@centextamilacademy.org" className="contact-item">
            <span className="icon">✉</span>
            <span className="text">admin@centextamilacademy.org</span>
          </a>
        </div>
        <div className="social-links">
          <a
            href="https://www.facebook.com/groups/centraltexastamilacademy"
            target="_blank"
            rel="noopener noreferrer"
            className="social-item facebook"
            title="Follow us on Facebook"
          >
            <span className="facebook-icon">f</span>
            <span className="text">Follow us</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default TopContactBar;
